import React from "react";
import avatar from "../../../Icon/avataaars.png";
import "./About.css";

const About = () => {
  return (
    <div className='container'>
      <h2 className="text-center pt-5 mt-5 pb-5" style={{ color: '#46475c'}}><b>About</b></h2>
      <div className="row about-section">
        <div className="col-md-6">
          <p className="about-description pt-5">
            I enjoy creating things that live on the internet, whether that be
            websites, applications, or anything in between. My goal is to always
            build products that provide pixel-perfect, performant experiences.
            organization.<br/>
            I love learn new tech and this has allowed me to stay
            active to learn new technologies and stay up-to-date on industry
            trends and development world. I build some web application and used
            different featureslike user authentications, database management
            system, admin panel system, server site applications, gateway
            payment method etc.
          </p>
        </div>
        <div className="col-md-6 d-flex justify-content-center">
          <img src={avatar} className="img-fluid avatar" alt="" />
        </div>
      </div>
    </div>
  );
};

export default About;
